import React from 'react';
import { motion } from 'framer-motion';
import { industries } from '../data/mock';
import { Pill, Cpu, Rocket, Heart, Dna, UtensilsCrossed, ArrowRight, Hospital, FlaskConical, GraduationCap } from 'lucide-react';

const iconMap = { Pill, Cpu, Rocket, Heart, Dna, UtensilsCrossed, Hospital, FlaskConical, GraduationCap };

const IndustriesSection = () => {
  return (
    <section id="industries" className="py-20 md:py-28 bg-[#FAFBFC]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="badge-minimal mb-6">Industries We Serve</span>
          <h2 className="title-minimal mb-4">
            Expertise Across <span className="title-accent">Sectors</span>
          </h2>
          <p className="text-base text-[#4A4A5A] max-w-2xl mx-auto">
            Specialized cleanroom solutions for the most demanding industries, 
            from pharmaceuticals to cutting-edge gene therapy.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => {
            const IconComponent = iconMap[industry.icon] || Pill;
            return (
              <motion.div
                key={industry.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="group relative overflow-hidden rounded-xl bg-white border border-[#E5E7EB] hover:border-[#1C4B8A]/30 transition-all"
              >
                {/* Image */}
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={industry.image}
                    alt={industry.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent" />
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 rounded-lg bg-white/20 backdrop-blur flex items-center justify-center">
                      <IconComponent className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="text-lg font-semibold text-white">{industry.name}</h3>
                  </div>
                  <p className="text-sm text-white/80 line-clamp-2">{industry.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
